export const config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
};